export const MAX_AVATARS_IN_COMPONENT = 4;
export const NO_OVERLAP_ID = -1;
